var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseGoogleIcon',_vm._g({style:(_vm.style),attrs:{"content":"more_horiz","iconStyle":_vm.iconStyle}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }